module.exports = __webpack_public_path__ + "assets/img/17_1047_big.fe8a02ec.jpg";